import { FileText, CheckCircle, Clock, AlertTriangle } from 'lucide-react';
import { MetricCard } from '@/components/reports/MetricCard';
import { InvoiceStats } from '@/types/invoice';
import { useCompanyLocale } from '@/hooks/useCompanyLocale';

interface InvoiceStatusCardsProps {
  data: InvoiceStats | undefined;
  isLoading: boolean;
}

export const InvoiceStatusCards = ({ data, isLoading }: InvoiceStatusCardsProps) => {
  const { formatMoney: formatCurrency } = useCompanyLocale();
  if (isLoading || !data) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-24 bg-muted animate-pulse rounded-lg" />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground">Invoice Status</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <MetricCard
          title="Total Invoiced"
          value={formatCurrency(data.totalInvoiced)}
          subtitle={`${data.invoiceCount} invoices`}
          icon={FileText}
          iconBgColor="bg-primary/10"
        />
        <MetricCard
          title="Invoices Paid"
          value={formatCurrency(data.totalPaid)}
          subtitle={`${data.paidCount} paid`}
          icon={CheckCircle}
          iconBgColor="bg-success/10"
          iconColor="text-success"
          valueColor="text-success"
        />
        <MetricCard
          title="Outstanding"
          value={formatCurrency(data.totalOutstanding)}
          subtitle={`${data.sentCount} pending`}
          icon={Clock}
          iconBgColor="bg-warning/10"
          iconColor="text-warning"
          valueColor="text-warning"
        />
        <MetricCard
          title="Overdue"
          value={formatCurrency(data.totalOverdue)}
          subtitle={`${data.overdueCount} overdue`}
          icon={AlertTriangle}
          iconBgColor="bg-destructive/10"
          iconColor="text-destructive"
          valueColor="text-destructive"
        />
      </div>
    </div>
  );
};
